import React, {FC, ReactNode} from 'react';

const style = {
	container: `flex flex-row`,
};

type DiscussionRowContainerProps = {
	children?: ReactNode;
	tailwindcss?: string;
};

export const DiscussionRowContainer: FC<DiscussionRowContainerProps> = ({
	children,
	tailwindcss,
}) => {
	return (
		<div className={`${style.container} ${tailwindcss ? tailwindcss : ''}`}>
			{children}
		</div>
	);
};
